/**
 * Formatting helpers shared across dashboard pages + cards.
 *
 * Kept small + inline-free: `lib/utils.ts` only ships `cn`, and these
 * came from pair-detail.tsx / overview.tsx duplicates. Any page that
 * renders money / pct / compact counts should import from here instead
 * of re-deriving them.
 */

/** Signed dollars with commas + 2 decimals: 1234.5 → "$1,234.50", -50 → "-$50.00". */
export function fmtMoney(n: number): string {
  const sign = n < 0 ? "-" : "";
  return `${sign}$${Math.abs(n).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** Used / limit as a %: 1-dp, "—" when limit is 0 or negative. */
export function fmtPct(used: number, limit: number): string {
  if (limit <= 0) return "—";
  return `${((used / limit) * 100).toFixed(1)}%`;
}

/** Compact large counts for headline stats. 1234 → "1.2k", 5_000_000 → "5.0M". */
export function fmtCompact(n: number): string {
  if (n < 1000) return String(n);
  if (n < 10_000) return `${(n / 1000).toFixed(1)}k`;
  if (n < 1_000_000) return `${Math.round(n / 1000)}k`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}
